/* eslint-disable yola/react/require-default-props */
import React, { forwardRef, useCallback } from 'react';
import { useController } from 'react-hook-form';
import LanguageSelect from '../language-select';
import FieldStatus from '../field-status';
import noop from '../../../utils/noop';

const defaultRules = {};

const LanguageSelectField = forwardRef(
  (
    { name, control, rules = defaultRules, options, onChange = noop, onBlur = noop, ...otherProps },
    ref
  ) => {
    const { field, fieldState } = useController({
      name,
      control,
      rules,
    });

    let defaultValue;

    if (options[0].options) {
      defaultValue = options[0].options.find(({ value }) => value === field.value);
    } else {
      defaultValue = options.find(({ value }) => value === field.value);
    }

    const handleChange = useCallback(
      (option) => {
        field.onChange(option?.value || defaultValue);
        onChange?.(option);
      },
      [field, defaultValue, onChange]
    );

    const handleBlur = useCallback(() => {
      field.onBlur();
      onBlur?.();
    }, [field, onBlur]);

    return (
      <React.Fragment>
        <LanguageSelect
          {...otherProps}
          ref={ref}
          defaultValue={defaultValue}
          options={options}
          invalid={fieldState.invalid}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
      </React.Fragment>
    );
  }
);

LanguageSelectField.displayName = 'LanguageSelectField';

export default LanguageSelectField;
